module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_m_leucistic.d45ce812.png";